import { cn } from "@u/cn";
import { type ReactNode } from "react";

export interface DashboardSectionProps {
  title?: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function DashboardSection({
  title,
  description,
  actions,
  className,
  children,
}: DashboardSectionProps) {
  const hasHeader = Boolean(title || description || actions);

  return (
    <section className={cn("space-y-4", className)}>
      {hasHeader && (
        <div className="flex items-end justify-between gap-4">
          <div className="min-w-0 space-y-1">
            {title && <h2 className="label-micro">{title}</h2>}
            {description && (
              <p className="text-sm text-muted-foreground">{description}</p>
            )}
          </div>
          {actions && (
            <div className="shrink-0 flex items-center gap-2">{actions}</div>
          )}
        </div>
      )}
      {children}
    </section>
  );
}
